import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  kpi: {
    reorderRequired: 0,
    deadStock: 0,
    expiryRisk: 0,
    pendingPO: 0,
    criticalAlerts: 0,
    totalProducts: 0,
    healthy: 0,
    lowStock: 0,
  },
  forecastData: [],
  pieData: { healthy: 0, low: 0, dead: 0, expiry: 0 },
  categoryData: [],
  stockTrend: [],
  todayActions: [],
  recentAlerts: [],
  festivalData: [],
  dashboardDetails: null,
  purchaseOrders: [],
  alertsArray: [],
  // Additional data for new routes
  inventoryHealth: [],
  deadStockList: [],
  expiryList: [],
  slowMovingList: [],
  fastMovingList: [],
  abcAnalysis: [],
  xyzAnalysis: [],
  purchaseRecommendations: [],
  recommendations: [],
  forecast: [],
};

const inventoryIntelligenceSlice = createSlice({
  name: "inventoryIntelligence",
  initialState,
  reducers: {
    setInventoryData(state, action) {
      const {
        kpi,
        forecastData,
        pieData,
        categoryData,
        stockTrend,
        todayActions,
        recentAlerts,
        festivalData,
        dashboardDetails,
        purchaseOrders,
        alertsArray,
        inventoryHealth,
        deadStockList,
        expiryList,
        slowMovingList,
        fastMovingList,
        abcAnalysis,
        xyzAnalysis,
        purchaseRecommendations,
        recommendations,
        forecast,
      } = action.payload;
      state.kpi = kpi;
      state.forecastData = forecastData;
      state.pieData = pieData;
      state.categoryData = categoryData;
      state.stockTrend = stockTrend;
      state.todayActions = todayActions;
      state.recentAlerts = recentAlerts;
      state.festivalData = festivalData;
      state.dashboardDetails = dashboardDetails;
      state.purchaseOrders = purchaseOrders;
      state.alertsArray = alertsArray;
      state.inventoryHealth = inventoryHealth || [];
      state.deadStockList = deadStockList || [];
      state.expiryList = expiryList || [];
      state.slowMovingList = slowMovingList || [];
      state.fastMovingList = fastMovingList || [];
      state.abcAnalysis = abcAnalysis || [];
      state.xyzAnalysis = xyzAnalysis || [];
      state.purchaseRecommendations = purchaseRecommendations || [];
      state.recommendations = recommendations || [];
      state.forecast = forecast || [];
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    setPurchaseOrders(state, action) {
      state.purchaseOrders = action.payload;
    },
    setAlerts(state, action) {
      state.alertsArray = action.payload;
    },
    setRecommendations(state, action) {
      state.recommendations = action.payload;
    },
    resetState: () => initialState,
  },
});

export const {
  setInventoryData,
  setLoading,
  setError,
  setPurchaseOrders,
  setAlerts,
  setRecommendations,
  resetState,
} = inventoryIntelligenceSlice.actions;

export default inventoryIntelligenceSlice.reducer;